import React, { Component } from 'react';
import './DeviceDetailPage.css';
import moment from 'moment';
import { connect } from 'react-redux';
import { t } from 'i18next';
import DetectionSplash from '../../subComponents/splashscreen/detectionResSplash';
import Modal from '../../subComponents/modals/Modal';
import NavBar from '../../subComponents/navBar/navBar';
import TitleBar from '../../../titleBar/TitleBar';
import CRUDTable from '../../subComponents/CRUDTable/CRUDTableComponent';
import TimeSeriesGraph from '../../subComponents/TensorGraphs/MovingAverageGraph/TimeSeriesGraph/TimeSeriesGraph';
import DeepARGraph from '../../subComponents/DeepARGraph/DeepARGraph';
import RCFGraphs from '../../subComponents/TensorGraphs/RCFGraphs/RCFGraphs';
import FailurePredictionGraphComponent from
  '../../subComponents/TensorGraphs/FailurePredictionGraph/FailurePredictionGraphComponent';
import {
  aylaDeviceDetail, createSchedule, getDSNAnomalyInfo,
  createDSNNote, getDSNNotes, removeDSN, singleCompletedRun, getInferenceResult, setSession,
} from '../../services/testResultsService';

class DeviceDetailPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      connectionStatus: '',
      counters: {
        failureCount: 0,
        forecastCount: 0,
        last24HoursAnomalies: 0,
        totalAnomalies: 0,
      },
      data: false,
      detectionModalShow: false,
      deviceDSN: props.match.params.deviceDSN,
      deviceFound: false,
      issues: [],
      jobNames: {
      },
      noteInfo: {
        note: '',
        operator: 'User',
        type: '',
      },
      notes: [],
      selectedJobName: false,
      showModal: false,
      stdeviation: 1,
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleNoteChange = this.handleNoteChange.bind(this);
    this.handleNoteJobNameChange = this.handleNoteJobNameChange.bind(this);
    this.addNote = this.addNote.bind(this);
    this.deactivateAnomaly = this.deactivateAnomaly.bind(this);
    this.generateDate = this.generateDate.bind(this);
    this.handleSTDChange = this.handleSTDChange.bind(this);
  }

  componentDidMount() {
    const { session } = this.props;
    setSession(session);
    const { deviceDSN } = this.state;
    this.getDeviceDetail(deviceDSN);
    this.getDSNInfo(session.access_token);
    if (! localStorage.DontShowDetection) {
      this.setState({
        detectionModalShow: true,
      });
    }
  }

  componentWillReceiveProps(props) {
    const { deviceDSN } = props.match.params;
    this.setState({
      deviceDSN,
    }, this.getDeviceDetail(deviceDSN));
  }

  getDSNInfo(token) {
    aylaDeviceDetail(token).then((result) => {
      this.setState({
        connectionStatus: result.device.connection_status
      });
    });
  }

  getDeviceDetail(deviceDSN) {
    getDSNAnomalyInfo(deviceDSN).then((result) => {
      const {
        anomlay, failure, forcast,
      } = result;
      const issuesList = [];
      const jobNames = {
      };

      anomlay.anomalyJobs.forEach(job => {
        if (job !== 'No Anomaly Jobs') {
          jobNames[job.jobName] = {
            jobName: job.jobName,
            runDate: job.runDate,
            type: 'Anomaly',
          };
          issuesList.push({
            jobName: job.jobName,
            occurences: job.occurenceCount,
            runDate: job.runDate,
            type: 'Anomaly',
          });
        }
      });
      failure.failureJobs.forEach(job => {
        if (job !== 'No Failure Jobs') {
          jobNames[job.jobName] = {
            jobName: job.jobName,
            runDate: job.runDate,
            type: 'Failure',
          };
          issuesList.push({
            jobName: job.jobName,
            occurences: job.occurenceCount,
            runDate: job.runDate,
            type: 'Failure',
          });
        }
      });
      forcast.forecastJobs.forEach(job => {
        if (job !== 'No Forecast Jobs') {
          jobNames[job.jobName] = {
            jobName: job.jobName,
            runDate: job.runDate,
            type: 'Forecast',
          };
          issuesList.push({
            jobName: job.jobName,
            occurences: job.occurenceCount,
            runDate: job.runDate,
            type: 'Forecast',
          });
        }
      });
      const firstJobName = Object.keys(jobNames)[0];
      this.setState({
        counters: {
          failureCount: failure.failureCount,
          forecastCount: forcast.forecastCount,
          last24HoursAnomalies: anomlay.anomlayCount,
          totalAnomalies: failure.failureCount + forcast.forecastCount + anomlay.anomlayCount,
        },
        deviceFound: true,
        issues: issuesList,
        jobNames,
        notes: [],
        selectedJobName: firstJobName ? jobNames[firstJobName] : false,
      }, () => {
        if (jobNames[firstJobName]) {
          this.getGraph(jobNames[firstJobName]);
          this.getNotes(jobNames[firstJobName].jobName, jobNames[firstJobName].type);
        }
      });
    });
  }

  getNotes(jobName, type) {
    const { deviceDSN } = this.state;
    getDSNNotes(deviceDSN, jobName, type).then((requestData) => {
      if (! requestData.notes) {
        this.setState({
          notes: [],
        });
        return;
      }
      const notes = [];
      requestData.notes.forEach((note) => {
        notes.push({
          date: note.Date,
          jobName,
          note: note.Message,
          operator: note.Operator,
          type,
        });
      });
      this.setState({
        notes,
      });
    });
  }

  getGraph(selectedJobName) {
    const { deviceDSN } = this.state;
    const {
      jobName, type, runDate,
    } = selectedJobName;
    if (! selectedJobName) return;
    getInferenceResult(runDate, 'SharkNinja', jobName, deviceDSN).then((response) => {
      const result = response.body.results;
      let data;
      if (type === 'Anomaly') {
        if (! Array.isArray(result)) {
          const firstKey = Object.keys(result)[0];
          if (Object.keys(result[firstKey]).includes('std')) {
            data = {
            };
            Object.keys(result).forEach((property) => {
              data[property] = result[property]['x-axis'].map((propertyData, i) => ({
                padding: result[property].std[i] || 0,
                raw: result[property].raw[i],
                std: result[property].result[i],
                x: new Date(result[property]['x-axis'][i]),
                y1: result[property].transform[i],
                y2: result[property].mean[i],
              }));
            });
            this.setState({
              dataGraph: {
                data,
                type: 'Moving Average'
              },
            });
          } else {
            data = {
            };
            Object.keys(result).forEach((property) => {
              data[property] = result[property]['x-axis'].map((propertyData, i) => ({
                raw: result[property].raw[i],
                result: result[property].result[i],
                transform: result[property].transform[i],
                'x-axis': new Date(result[property]['x-axis'][i]),
              }));
            });
            this.setState({
              dataGraph: {
                data,
                type: 'Random Cut Forest'
              },
            });
          }
        } else {
          this.setState({
            dataGraph: {
              data: result,
              type: 'KMeans'
            },
          });
        }
      } else if (type === 'Failure') {
        // only XGBoost will have result due to CDF returning different property for output data
        if (result) {
          // const selectedProperty = Object.keys(response.body.results)[0];

          // const time = result.selectedProperty;
          // const data = {}
          Object.keys(result).forEach((property) => {
            data[property] = result[property]['x-axis'].map((propertyData, i) => ({
              raw: result[property].raw[i],
              result: result[property].result[i],
              transform: result[property].transform[i],
              'x-axis': new Date(result[property]['x-axis'][i]),
            }));
          });

          this.setState({
            dataGraph: {
              data,
              type: 'XGBoost'
            }
          });
        } else {
          data = {
            label: 'TestLabel',
            values: response.body['x-axis'].map((dataXPoint, index) => ({
              x: new Date(dataXPoint),
              y: parseInt(response.body.anomaly_score[index], 10),
            })),
          };
          this.setState({
            dataGraph: {
              data,
              type: 'Cumulative Distribution Function'
            },
          });
        }
      } else if (type === 'Forecast') {
        data = result.index.map((xValue, index) => ({
          lowerlayer: result['0.4'][index],
          upperlayer: result['0.6'][index],
          x: new Date(xValue),
          y: result['0.5'][index],
        }));
        this.setState({
          dataGraph: {
            data,
            type: 'DeepAR'
          },
        });
      } else {
        this.setState({
          dataGraph: {
            data: [],
            type: 'None'
          },
        });
      }
    }).catch((e) => {
      console.error('Error in retrieving graph by jobName', e);
      this.setState({
        dataGraph: {
          data: [],
          type: 'None'
        },
      });
    });
  }

  closeModal() {
    this.setState({
      detectionModalShow: false,
      showModal: false,
    });
  }

  openModal() {
    this.setState({
      showModal: true,
    });
  }

  addNote() {
    const {
      deviceDSN, noteInfo, notes, selectedJobName
    } = this.state;
    const notesCopy = notes.slice(0);
    const noteData = {
      ...noteInfo,
      jobName: selectedJobName.jobName,
    };
    createDSNNote(deviceDSN, noteData).then((requestData) => {
      if (requestData.message) {
        notesCopy.push(noteData);
        this.setState({
          notes: notesCopy,
        });
      }
    }).catch((error) => {
      console.error('Error', error);
    });
  }

  deactivateAnomaly() {
    const {
      deviceDSN,
      selectedJobName,
    } = this.state;
    removeDSN(deviceDSN, selectedJobName.jobName, selectedJobName.type).then(requestData => {
      if (requestData) {
        this.getDeviceDetail(deviceDSN);
      }
    });
  }

  handleNoteChange(event) {
    const { noteInfo } = this.state;
    this.setState({
      noteInfo: {
        ...noteInfo,
        note: event.target.value,
      },
    });
  }

  handleNoteJobNameChange(jobName) {
    const { jobNames, noteInfo } = this.state;
    this.setState({
      noteInfo: {
        ...noteInfo,
        type: jobNames[jobName].type,
      },
      selectedJobName: jobNames[jobName],
    }, () => {
      this.getNotes(jobName, jobNames[jobName].type);
      this.getGraph(jobNames[jobName]);
    });
  }

  handleSTDChange(event) {
    this.setState({
      stdeviation: parseFloat(event.target.value),
    });
  }

  generateDate() {
    const date = moment().format('YYYYMMDDHHmm');
    this.scheduleNow(date);
  }

  scheduleNow(date) {
    const { selectedJobName: { jobName, runDate }, deviceDSN } = this.state;
    const newName = `${jobName}${date}`;
    this.setState({
      newName
    });
    singleCompletedRun(jobName, runDate).then((result) => {
      const {
        DeviceModelType, ModelName, ModelPlotType,
        Normalization, OemID, Threshold, VersionID,
      } = result.body;
      const jdate = new Date();
      const utcDate = jdate.toISOString();

      const batch = {
        dayOfMonth: [],
        dayOfWeek: [],
        devices: [],
        deviceType: DeviceModelType,
        endDate: moment().subtract(1, 'days'),
        frequency: 'Immediate',
        jobname: newName,
        jobStatus: [],
        modelName: ModelName,
        modelPlotType: ModelPlotType,
        normalization: Normalization,
        oemId: OemID,
        scheduleDate: moment(),
        // software version will need to pulled from the redux store after integration
        softwareVersion: 'version 1.0',
        startDate: moment().subtract(8, 'days'),
        threshold: Threshold,
        timoOfDay: [],
        versionId: VersionID,
      };
      moment().subtract(7, 'days');

      const start = batch.startDate;
      const end = batch.endDate;
      const s = moment.utc(start).startOf('day');
      const e = moment.utc(end).startOf('day');
      const startDate = s.format('YYYYMMDD[T]HH:mm:ss.SSS[Z]');
      const endDate = e.format('YYYYMMDD[T]HH:mm:ss.SSS[Z]');
      batch.startDate = startDate;
      batch.endDate = endDate;
      batch.createDate = utcDate;
      batch.devices.push(deviceDSN);
      createSchedule(batch);
    });
    setTimeout(this.closeModal, 2000);
  }

  render() {
    const {
      connectionStatus, data, dataGraph, deviceFound, deviceDSN, issues, selectedJobName, newName,
      noteInfo, notes, detectionModalShow, showModal, stdeviation,
      counters: {
        totalAnomalies, last24HoursAnomalies, failureCount, forecastCount,
      },
    } = this.state;

    let splashScreen;
    let splashModal;
    if (detectionModalShow) {
      splashScreen = (
        <DetectionSplash closeModal={this.closeModal} />
      );
      splashModal = (
        <Modal close={this.closeModal}
          title={t('tensorAnalytics.deviceDetailPage.newToResults')}
          style={{
            width: '95%',
          }}
        >
          {splashScreen}
        </Modal>
      );
    }

    const columns = [{
      accessor: 'operator',
      Header: t('tensorAnalytics.tableHeaders.operator'),
    }, {
      accessor: 'date',
      Cell: row => (
        <div>
          {moment(row.value).format('MM/DD/YY h:mm:ss a')}
        </div>
      ),
      Header: t('tensorAnalytics.tableHeaders.noteDate'),
    }, {
      accessor: 'note',
      Header: t('tensorAnalytics.tableHeaders.note'),
    }, {
      accessor: 'type',
      Header: t('tensorAnalytics.tableHeaders.type'),
    }];

    const children = (
      <div>
        <button type="button"
          className="schedule-btn"
          onClick={this.generateDate}
        >
          {t('tensorAnalytics.deviceDetailPage.scheduleNow')}
        </button>
        <button type="button"
          className="cancel-btn"
          onClick={this.closeModal}
        >
          {t('tensorAnalytics.common.cancel')}
        </button>
        <div className="schedule-name-container">
          <span>{`${t('tensorAnalytics.deviceDetailPage.scheduleName')}:`}</span>
          <span>{newName}</span>
        </div>
      </div>
    );
    let modal;
    if (showModal) {
      modal = (
        <Modal close={this.closeModal}
          title={t('tensorAnalytics.deviceDetailPage.areYouSure')}
          style={{
            width: '30%',
          }}
        >
          {children}
        </Modal>
      );
    }
    // console.log(dataGraph);

    const jobNameGraph = () => {
      if (! dataGraph || ! selectedJobName) return false;
      if (dataGraph.type === 'Moving Average') {
        return (
          <div className="graph-row">
            <div className="graph-row-content">
              <div className="stdField">
                {`${t('tensorAnalytics.graphs.timeSeriesGraph.anomaliesInput')} :`}
                <input type="number"
                  className="devInput"
                  step="0.1"
                  value={stdeviation}
                  onChange={this.handleSTDChange}
                />
              </div>
            </div>
            {Object.keys(dataGraph.data).map((property) => (
              <TimeSeriesGraph data={dataGraph.data[property]}
                propertyText={property}
                height={250}
                key={property}
                stdeviation={stdeviation}
                yAxisTitle={`${property} ${t('tensorAnalytics.graphs.timeSeriesAxis')}`}
                colors={{
                  anomalyColor: '#ff4a4a',
                  areaColor: '#E5E5FE',
                  meanColor: '#e66000',
                  transformColor: '#D5B98B',
                }}
                labels={{
                  anomalyLabel: t('tensorAnalytics.graphs.timeSeriesGraph.anomalyDetected'),
                  areaLabel: t('tensorAnalytics.graphs.timeSeriesGraph.std'),
                  meanLabel: t('tensorAnalytics.graphs.timeSeriesGraph.mean'),
                  transformLabel: t('tensorAnalytics.graphs.timeSeriesGraph.transform'),
                }}
              />
            ))}
          </div>
        );
      }
      if (dataGraph.type === 'KMeans') {
        return (
          <div>
            {'Kmeans Graph'}
          </div>
        );
      }
      if (dataGraph.type === 'Random Cut Forest') {
        return (
          <div>
            {dataGraph.data && Object.keys(dataGraph.data).map((property) => (
              <RCFGraphs data={dataGraph.data[property]}
                propertyText={property}
                height={275}
                key={property}
              />
            ))}
          </div>
        );
      }
      if (dataGraph.type === 'XGBoost') {
        return (
          <div>
            {dataGraph.data && Object.keys(dataGraph.data).map((property) => (
              <RCFGraphs data={dataGraph.data[property]}
                yAxisLabel="Time to Failure (min)"
                propertyText={property}
                height={275}
                key={property}
              />
            ))}
          </div>
        );
      }
      if (dataGraph.type === 'DeepAR') {
        return (
          <div>
            <DeepARGraph data={dataGraph.data}
              propertyText="Property"
            />
          </div>
        );
      }
      if (dataGraph.type === 'Cumulative Distribution Function') {
        return (
          <div>
            <FailurePredictionGraphComponent fromPlotService={false}
              propsData={dataGraph.data.values}
            />
          </div>
        );
      }
      return (
        <div>
          {'Invalid Data'}
        </div>
      );
    };

    return (
      <div className="DeviceDetail page">
        <TitleBar title={t('tensorAnalytics.deviceDetailPage.title')} />
        <NavBar />
        <div className="pageContent">
          <div className="section">
            <div className="title">{t('tensorAnalytics.deviceDetailPage.sectionTitle')}</div>
            <div className="description">{t('tensorAnalytics.deviceDetailPage.sectionDescription')}</div>
            {deviceFound && (
              <div className="content">
                <div className="detail">
                  <div className="lists">
                    <div className="list currentState">
                      <div className="row header">
                        <span>{t('tensorAnalytics.deviceDetailPage.currentState.title')}</span>
                        <span />
                      </div>
                      <div className="row">
                        <span className="label">
                          {`${t('tensorAnalytics.deviceDetailPage.currentState.DSN')}:`}
                        </span>
                        <span className="value">{deviceDSN}</span>
                      </div>
                      <div className="row">
                        <span className="label">
                          {`${t('tensorAnalytics.deviceDetailPage.currentState.status')}:`}
                        </span>
                        <span className={`value ${connectionStatus ? 'online' : 'offline'}`}>
                          {/* {data.status ? 'Online' : 'Offline'} */}
                          {connectionStatus}
                        </span>
                      </div>
                      <div className="row">
                        <span className="label">
                          {`${t('tensorAnalytics.deviceDetailPage.currentState.username')}:`}
                        </span>
                        <span className="value">{data.username}</span>
                      </div>
                      <div className="row">
                        <span className="label">
                          {`${t('tensorAnalytics.deviceDetailPage.currentState.useremail')}:`}
                        </span>
                        <span className="value">{data.useremail}</span>
                      </div>
                      <div className="row">
                        <span className="label">
                          {`${t('tensorAnalytics.deviceDetailPage.currentState.location')}:`}
                        </span>
                        <span className="value">{data.location}</span>
                      </div>
                      <div className="row">
                        <span className="label">
                          {`${t('tensorAnalytics.deviceDetailPage.currentState.totalAnomalies')}:`}
                        </span>
                        <span className="value">{totalAnomalies}</span>
                      </div>
                      <div className="row">
                        <span className="label">
                          {`${t('tensorAnalytics.deviceDetailPage.currentState.last24HoursAnomalies')}:`}
                        </span>
                        <span className="value">{last24HoursAnomalies}</span>
                      </div>
                      <div className="row">
                        <span className="label">
                          {`${t('tensorAnalytics.deviceDetailPage.currentState.predictiveFailures')}:`}
                        </span>
                        <span className="value">{failureCount}</span>
                      </div>
                      <div className="row">
                        <span className="label">
                          {`${t('tensorAnalytics.deviceDetailPage.currentState.forecastedEvents')}:`}
                        </span>
                        <span className="value">{forecastCount}</span>
                      </div>
                    </div>
                    <div className="list currentState">
                      <div className="row header">
                        <span>{t('tensorAnalytics.deviceDetailPage.issuesList.jobName')}</span>
                        <span>{t('tensorAnalytics.deviceDetailPage.issuesList.issueType')}</span>
                        <span>{t('tensorAnalytics.deviceDetailPage.issuesList.occurences')}</span>
                      </div>
                      {
                        issues && issues.map(issue => (
                          <div key={issue.jobName}
                            onClick={() => this.handleNoteJobNameChange(issue.jobName)}
                            onKeyPress={() => this.handleNoteJobNameChange(issue.jobName)}
                            role="button"
                            tabIndex="0"
                            className={
                              `row ${selectedJobName.jobName === issue.jobName ? 'selected' : 'notselected'}`
                            }
                          >
                            <span className="label">{`${issue.jobName}`}</span>
                            <span className="type">{`${issue.type}`}</span>
                            <span className="occurences">{`${issue.occurences}`}</span>
                          </div>
                        ))
                      }
                    </div>
                  </div>
                  <div className="deviceActions">
                    <button onClick={this.deactivateAnomaly}
                      className="deactivateAnomaly"
                      type="button"
                      disabled={! selectedJobName && ! selectedJobName.jobName}
                    >
                      {selectedJobName && selectedJobName.jobName === 0
                        ? t('tensorAnalytics.deviceDetailPage.deactivateAnomalyEmpty')
                        : t('tensorAnalytics.deviceDetailPage.deactivateAnomaly', {
                          jobName: selectedJobName.jobName,
                        })
                      }
                    </button>
                    <button onClick={this.openModal}
                      className="schedule-btn"
                      type="button"
                      disabled={! selectedJobName && ! selectedJobName.jobName}
                    >
                      {'Schedule Immediate Inference'}
                    </button>
                  </div>
                  <div className="detail-notes">
                    <div className="add-note">
                      <button onClick={this.addNote}
                        disabled={noteInfo.note.length === 0 || (! selectedJobName && ! selectedJobName.jobName)}
                        type="button"
                      >
                        {t('tensorAnalytics.deviceDetailPage.addNote')}
                      </button>
                      <input placeholder={t('tensorAnalytics.deviceDetailPage.notePlaceholder')}
                        value={noteInfo.note}
                        onChange={this.handleNoteChange}
                      />
                    </div>
                    { notes && (
                      <CRUDTable data={notes}
                        columns={columns}
                        style={{
                          height: '200px',
                        }}
                        noDataText={t('tensorAnalytics.deviceDetailPage.selectedJobNameNotes', {
                          jobName: selectedJobName.jobName
                        })}
                      />
                    )}
                  </div>
                </div>
                <div className="detail-graph">
                  {selectedJobName && jobNameGraph()}
                </div>
              </div>
            )}
            {! deviceFound && (
              <div className="content">
                {t('tensorAnalytics.deviceDetailPage.deviceNotFound')}
              </div>
            )}
          </div>
          <div className="schedule-now-modal">
            {modal}
          </div>
          <div className={detectionModalShow ? 'show' : 'hide'}>
            {splashModal}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => state)(DeviceDetailPage);
